import { RouteConfig } from 'vue-router';
import { RouterPath } from '../shared/enums';

export default (): Array < RouteConfig > => {
    return [{
            path: RouterPath.HOME,
            component: () => import ('./components/pages/page-home').then(m => m.default)
        }
    ];
};
